// Copyright (c) 2019 Deere & Company

import WearPartsClaim from '@deere/cps-it.warranty-model-factory/lib/claim-wear-part';

export const getUpdatedWearPartsClaim = (currentClaim, selectedAction) =>
    WearPartsClaim.update(currentClaim, {
        selectedAction: {
            $set: selectedAction
        }
    });



// WEBPACK FOOTER //
// ./src/claim/wear-parts/services/update-wear-parts-claim.js